import React, { useEffect, useState, useMemo, useRef } from "react";
import { FaBullhorn, FaUserFriends, FaChartLine } from "react-icons/fa";

export default function StatsCounter() {

  const statsRef = useRef(null); 
  const [startCount, setStartCount] = useState(false);

  const stats = useMemo(() => [
    { label: "Campaigns", value: 400, color: "#ff006e", icon: <FaBullhorn /> },
    { label: "Creators", value: 40000, color: "#ff5e00ff", icon: <FaUserFriends /> },
    { label: "Reach", value: 50, suffix: " Mn", color: "#ff8c00", icon: <FaChartLine /> },
  ], []);

  const [counts, setCounts] = useState(stats.map(() => 0));

  // 👇 FIXED IntersectionObserver cleanup
  useEffect(() => {
    const element = statsRef.current; // store ref value (fix!)
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element); // cleanup uses stored element
    };
  }, []);

  // 👇 counter only when visible
  useEffect(() => {
    if (!startCount) return;

    stats.forEach((stat, index) => {
      let start = 0;
      const end = stat.value;
      const duration = 1500;
      const step = Math.ceil(end / (duration / 16));

      const counter = setInterval(() => {
        start += step;
        if (start >= end) {
          start = end;
          clearInterval(counter);
        }

        setCounts((prev) => {
          const updated = [...prev];
          updated[index] = start;
          return updated;
        });
      }, 16);

      return () => clearInterval(counter);
    });
  }, [startCount, stats]);

  return (
    <div
      ref={statsRef}
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: "60px",
        padding: "80px 40px",
        fontFamily: "Poppins, sans-serif",
        textAlign: "center",
      }}
    >
      {/* Left Image */}
      <div
        style={{
          flex: "1 1 45%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="motion-image">
          <img
            src="/Generated.jpeg"
            alt="Division Overview"
            style={{
              width: "100%",
              maxWidth: "500px",
              borderRadius: "20px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
              transition: "transform 0.6s ease, box-shadow 0.6s ease",
              animation: "floatImage 4s ease-in-out infinite",
            }}
          />
        </div>
      </div>

      {/* Stats section */}
      <div
        style={{
          flex: "1 1 45%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "40px",
        }}
      >
        {stats.map((stat, index) => (
          <div key={index}>
            <div
              style={{
                fontSize: "40px",
                color: stat.color,
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              {stat.icon} {stat.label}
            </div>

            <div
              style={{
                fontSize: "70px",
                fontWeight: "800",
                color: stat.color,
              }}
            >
              {counts[index]}
              {counts[index] === stat.value && "+"}
              {stat.suffix && counts[index] === stat.value ? stat.suffix : ""}
            </div>
          </div>
        ))}
      </div>

      <style>
        {`
          @keyframes floatImage {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }

          .motion-image img:hover {
            transform: scale(1.08) rotate(1deg);
            box-shadow: 0 12px 35px rgba(255, 110, 0, 0.3);
          }
        `}
      </style>
    </div>
  );
}
